const commonStyles = {
  fontFamilies: {
    primary: "'Inter', sans-serif", // For headings, UI elements
    secondary: "'Source Sans Pro', sans-serif", // For body text
  },
  fontSizes: {
    h1: '2.25rem',    // approx 36px
    h2: '1.75rem',    // approx 28px
    h3: '1.375rem',   // approx 22px
    body: '1.125rem',  // 18px for better readability
    caption: '0.875rem', // 14px
    small: '0.75rem',   // 12px
  },
  lineHeights: {
    body: 1.7,
    heading: 1.3,
  },
  borderRadius: '8px', // Consistent border radius
};

export const lightTheme = {
  ...commonStyles,
  colors: {
    background: '#FDFDFD',
    surface: '#FFFFFF',
    text: '#212121',
    textSecondary: '#5F5F5F',
    primary: '#FCA311',      // Saffron-inspired orange
    secondary: '#A0B2C0',    // Calm blue-gray
    accentHover: '#E69500',   // Darker saffron for hover
    borders: '#E0E0E0',
    success: '#4CAF50',
    error: '#F44336',
    link: '#FCA311',         // Same as primary
  },
  // For components that might still be using props.theme.fonts (old structure) directly,
  // provide a fallback. This should be removed after component refactoring.
  fonts: commonStyles.fontFamilies.secondary, // Fallback to body font
  // Fallbacks for direct color access - to be removed after component refactoring
  background: '#FDFDFD',
  surface: '#FFFFFF',
  text: '#212121',
  primary: '#FCA311',
  secondary: '#A0B2C0',
  accent: '#FCA311', // Assuming accent is same as primary for now
  link: '#FCA311',
  navBackground: '#FFFFFF', // Example, adjust as needed
  navText: '#212121',      // Example, adjust as needed
};

export const darkTheme = {
  ...commonStyles,
  colors: {
    background: '#1F1F1F',
    surface: '#2C2C2C',
    text: '#EAEAEA',
    textSecondary: '#B0B0B0',
    primary: '#FFB74D',      // Lighter/desaturated saffron
    secondary: '#546E7A',    // Deeper blue-gray
    accentHover: '#FCA311',   // Brighter saffron for hover on dark
    borders: '#424242',
    success: '#66BB6A',
    error: '#EF5350',
    link: '#FFB74D',         // Same as primary for dark theme
  },
  // Fallbacks for direct color access - to be removed after component refactoring
  fonts: commonStyles.fontFamilies.secondary, // Fallback to body font
  background: '#1F1F1F',
  surface: '#2C2C2C',
  text: '#EAEAEA',
  primary: '#FFB74D',
  secondary: '#546E7A',
  accent: '#FCA311', // Assuming accent is same as dark theme primary's hover for now
  link: '#FFB74D',
  navBackground: '#2C2C2C', // Example, adjust as needed
  navText: '#EAEAEA',      // Example, adjust as needed
};
